import api from './apiClient';

export const authAPI = {
  async login(credentials) {
    try {
      return await api.post('/auth/login', credentials);
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  async register(userData) {
    try {
      return await api.post('/auth/register', userData);
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  },

  async logout() {
    try {
      return await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },

  async refreshToken() {
    try {
      return await api.post('/auth/refresh');
    } catch (error) {
      console.error('Token refresh error:', error);
      throw error;
    }
  },

  async getProfile() {
    try {
      return await api.get('/auth/profile');
    } catch (error) {
      console.error('Get profile error:', error);
      throw error;
    }
  },

  async changePassword(data) {
    try {
      return await api.put('/auth/change-password', data);
    } catch (error) {
      console.error('Change password error:', error);
      throw error;
    }
  },

  async requestPasswordReset(email) {
    try {
      return await api.post('/auth/request-password-reset', { email });
    } catch (error) {
      console.error('Request password reset error:', error);
      throw error;
    }
  },

  async resetPassword(token, newPassword) {
    try {
      return await api.post('/auth/reset-password', { token, newPassword });
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  },

  async validateResetToken(token) {
    try {
      return await api.post('/auth/reset-password/validate', { token });
    } catch (error) {
      console.error('Validate reset token error:', error);
      throw error;
    }
  },

  async resendEmailVerification() {
    try {
      return await api.post('/auth/resend-verification');
    } catch (error) {
      console.error('Resend verification error:', error);
      throw error;
    }
  },
};

export default authAPI;

